import { axiosClient } from 'src/configs/axios'

//send SMS
export const sendSMS = async payload => {
  return axiosClient.post('/sendsms/send', payload)
}
